import React, { useEffect, useState, useRef } from "react";
import {
  Loader,
  Container,
  Segment,
  Button,
  Icon,
  Divider,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as scuolaActions from "../../redux/actions/scuolaActions";
import * as cartActions from "../../redux/actions/cartActions";
import * as corsiApi from "../../api/corsiApi";
import TestataPagina from "../common/TestataPagina";
import SchedaAllievoCorso from "./SchedaAllievoCorso";
import useWindowSize from "../../utils/useWindowSize";
//import CartMain from "../cart/CartMain";
import CartPortal from "../common/CartPortal";
import { useTranslation } from "react-i18next";
import * as skiworkUtilis from "../../utils/skiworkUtils";
import ScalapayFrase from "../common/ScalapayFrase";

function CollettiveAllievi({
  appData,
  datiScuola,
  addCollettiva,
  setReferrer,
  ...props
}) {
  ///////////////////////////////////////
  //STATE
  const [isLoading, setIsLoading] = useState(true);
  const [isValid] = useState(true);
  const [checkOutOpen, setCheckOutOpen] = useState(false);
  const [listaServizi, setListaServizi] = useState(undefined);
  const [datiAllievi, setDatiAllievi] = useState(() => {
    const allieviArray = [];
    for (let i = 0; i < appData.prefsCorso.numAllievi; i++) {
      allieviArray.push({
        nome: "",
        cognome: "",
        sesso: "M",
        anno: 0,
        livello: "-1",
        dataNascita: null,
        luogoNascita: "",
      });
    }
    return allieviArray;
  });
  const [errorsAllievi, setErrorsAllievi] = useState(() => {
    const errorsArray = [];
    for (let i = 0; i < appData.prefsCorso.numAllievi; i++) {
      errorsArray.push({});
    }
    return errorsArray;
  });
  const [serviziAllievo, setServiziAllievo] = useState(() => {
    const serviziArray = [];
    for (let i = 0; i < appData.prefsCorso.numAllievi; i++) {
      serviziArray.push([]);
    }
    return serviziArray;
  });
  const windowSize = useWindowSize();
  const history = useHistory();
  const { t, i18n } = useTranslation([datiScuola.customTranslationNamespace]);
  useEffect(() => {
    i18n.emit("languageChanged");
  }, [datiScuola.customTranslationNamespace]);

  const inizioAllieviRef = useRef();
  // const transition = "fly left";
  // const duration = 500;

  ///////////////////////////////////////
  //EFFECT HOOKS
  useEffect(() => {
    //todo effettuare check per coerenza lingua e scuola
    setIsLoading(true);
    const loadServizi = async () => {
      const res = await corsiApi.getServiziDisponibili(
        datiScuola.id,
        appData.corsoDettagli.idCorso,
        appData.prefsCorso.primaData === undefined
          ? "1900-01-01"
          : appData.prefsCorso.primaData, //moment().format("YYYY-MM-DD"),
        datiScuola.idLinguaInUso,
        -1
      );
      setListaServizi(res.listaTipologie);
      setIsLoading(false);
    };
    loadServizi();
  }, []);

  useEffect(() => {
    if (appData.hasOwnProperty("lang")) {
      i18n.changeLanguage(appData.lang.toLowerCase());
    }
  }, [appData.lang]);

  //////////////////////////////////////////////
  //HANDLERS
  function handleAddServizio(allievo, idServizio, prezzo, descrizione) {
    //Se il servizio esiste già per l'allievo, lo rimuovo
    const idx = serviziAllievo[allievo - 1].findIndex(
      (x) => x.id === idServizio
    );

    let tuttiServizi = [...serviziAllievo];
    //let sa = [...serviziAllievo[allievo - 1]];

    if (idx < 0) {
      //aggiunta
      tuttiServizi[allievo - 1] = tuttiServizi[allievo - 1].concat({
        id: idServizio,
        prezzo: prezzo,
        descrizione: descrizione,
      });
    } else {
      //rimozione
      tuttiServizi[allievo - 1] = tuttiServizi[allievo - 1].slice();
      tuttiServizi[allievo - 1].splice(idx, 1);
    }

    setServiziAllievo(tuttiServizi);
  }

  function handleAllievoChange(idx, field, value) {
    const datiAllieviTmp = [...datiAllievi];

    datiAllieviTmp[idx - 1][field] = value;
    setDatiAllievi(datiAllieviTmp);

    const errorsTmp = [...errorsAllievi];
    errorsTmp[idx - 1][field] = false;
    setErrorsAllievi(errorsTmp);
  }

  function handleAggiuntaCarrello() {
    if (checkErrors()) {
      return;
    }

    //Verifico la data/anno di nascita
    const allievi = datiAllievi;
    if (datiScuola.dataLuogoNascita === true) {
      for (let i = 0; i < allievi.length; i++) {
        allievi[i].anno = allievi[i].dataNascita.getFullYear();
      }
    }

    //correggo i livelli

    for (let i = 0; i < allievi.length; i++) {
      if (parseInt(allievi[i].livello) !== -1) {
        if (allievi[i].cognome !== "") {
          allievi[i].livello = datiScuola.tLivelli.filter(
            (x) => x.id === parseInt(allievi[i].livello)
          )[0].idLivelloIso;
        }
      }
    }

    addCollettiva({
      ...appData.corsoDettagli,
      startDate: appData.prefsCorso.primaData,
      numGiorniScelti: appData.prefsCorso.numGiorni,
      numSessioni: appData.prefsCorso.numSessioni,
      numAllievi: appData.prefsCorso.numAllievi,
      prezzo: appData.prefsCorso.prezzo,
      prezzoPag: appData.prefsCorso.prezzoPag,
      listaDate: appData.prefsCorso.listaDate,
      allievi: allievi,
      serviziAllievo: serviziAllievo,
    });

    setReferrer("collettive");
    if (windowSize.width > 600) {
      setCheckOutOpen(true);
    } else {
      history.push(`/${appData.lang}/${appData.slug}/cart`);
    }
  }

  function handleCartPortalClose() {
    history.push(`/${appData.lang}/${appData.slug}/collettive`);
  }

  /////////////////////////////////////////
  //HELPERS
  function getTotaleServizi() {
    let tot = 0;

    for (let [key, value] of Object.entries(
      //appData.corsoDettagli.serviziAllievo
      serviziAllievo
    )) {
      for (let i = 0; i < value.length; i++) {
        tot += value[i].prezzo;
      }
    }

    return tot;
  }

  function checkErrors() {
    const errorsTmp = [...errorsAllievi];
    let error = false;
    for (let i = 0; i < appData.prefsCorso.numAllievi; i++) {
      if (datiAllievi[i].nome.length < 2) {
        errorsTmp[i].nome = true;
        error = true;
      }
      if (datiAllievi[i].cognome.length < 2) {
        errorsTmp[i].cognome = true;
        error = true;
      }
      if (datiAllievi[i].sesso.length < 1) {
        errorsTmp[i].sesso = true;
        error = true;
      }
      if (datiScuola.dataLuogoNascita !== true && datiAllievi[i].anno < 1900) {
        errorsTmp[i].anno = true;
        error = true;
      }

      const livelliAttivi = skiworkUtilis.getLivelli(
        datiScuola,
        appData.corsoDettagli.idCorso
      );
      if (parseInt(datiAllievi[i].livello) <= 0 && livelliAttivi.length > 0) {
        errorsTmp[i].livello = true;
        error = true;
      }
      if (
        datiScuola.dataLuogoNascita === true &&
        datiAllievi[i].luogoNascita.length < 1
      ) {
        errorsTmp[i].luogoNascita = true;
        error = true;
      }
      if (
        datiScuola.dataLuogoNascita === true &&
        datiAllievi[i].dataNascita === null
      ) {
        errorsTmp[i].dataNascita = true;
        error = true;
      }
    }

    if (error) {
      inizioAllieviRef.current.scrollIntoView(true, {
        behavior: "smooth",
        block: "start",
      });
      setErrorsAllievi(errorsTmp);
    }

    return error;
  }

  /////////////////////////////////////////////////
  //RENDER FUNTIONS
  function renderAllievi() {
    let allievi = [];
    for (let i = 0; i < appData.prefsCorso.numAllievi; i++) {
      allievi.push(
        <SchedaAllievoCorso
          num={i + 1}
          datiAllievo={datiAllievi[i]}
          datiCorso={appData.corsoDettagli}
          errors={errorsAllievi[i]}
          numGiorni={appData.prefsCorso.numGiorni}
          datiScuola={datiScuola}
          serviziDisponibili={listaServizi}
          onServizioAggiunto={handleAddServizio}
          onChange={handleAllievoChange}
          serviziAttivi={serviziAllievo[i]}
          livelli={datiScuola.livelli}
          key={i}
        />
      );
    }
    return allievi;
  }

  function renderPrezzo() {
    const acconto = appData.prefsCorso.prezzo !== appData.prefsCorso.prezzoPag;

    // if (appData.corsoDettagli.numAllievi === 1) {
    //   if (acconto) {
    //     return (
    //       <Segment textAlign="right" basic className="padding_5_lr">
    //         <label>{t("prezzo_corso")}</label>
    //         <p className="prezzo_parziale" style={{ marginBottom: "0px" }}>
    //           {datiScuola.valuta} {appData.prefsCorso.prezzo.toFixed(2)}
    //         </p>
    //         {getTotaleServizi() > 0 && (
    //           <>
    //             <label>{t("totale_servizi")}</label>
    //             <p className="prezzo_parziale">
    //               {datiScuola.valuta} {getTotaleServizi().toFixed(2)}
    //             </p>
    //           </>
    //         )}
    //         <Divider />
    //         <label>{t("acconto")}</label>
    //         <p className="prezzo_totale" style={{ marginBottom: "0px" }}>
    //           {datiScuola.valuta} {appData.prefsCorso.prezzoPag.toFixed(2)}
    //         </p>
    //       </Segment>
    //     );
    //   }
    //   return (
    //     <Segment textAlign="right" basic className="padding_5_lr">
    //       <label>{t("prezzo_corso")} X</label>
    //       <p
    //         className={
    //           getTotaleServizi() > 0 ? "prezzo_parziale" : "prezzo_totale"
    //         }
    //       >
    //         {datiScuola.valuta} {appData.prefsCorso.prezzo.toFixed(2)}
    //       </p>
    //       {getTotaleServizi() > 0 && (
    //         <>
    //           <label>{t("totale_servizi")}</label>
    //           <p className="prezzo_parziale">
    //             {datiScuola.valuta} {getTotaleServizi().toFixed(2)}
    //           </p>
    //           <Divider />
    //           <label>{t("totale")}</label>
    //           <p className="prezzo_totale" style={{ marginBottom: "0px" }}>
    //             {datiScuola.valuta}{" "}
    //             {(appData.prefsCorso.prezzo + getTotaleServizi()).toFixed(2)}
    //           </p>
    //         </>
    //       )}
    //       <div>xxx</div>
    //     </Segment>
    //   );
    // } else

    if (acconto) {
      return (
        <Segment textAlign="right" basic className="padding_5_lr">
          <label>{t("prezzo_corso")}</label>
          <p className="prezzo_parziale">
            <span>{appData.prefsCorso.numAllievi} x </span>
            {datiScuola.valuta} {appData.prefsCorso.prezzo.toFixed(2)}
          </p>
          {getTotaleServizi() > 0 && (
            <>
              <label>{t("totale_servizi")}</label>
              <p className="prezzo_parziale">
                {datiScuola.valuta} {getTotaleServizi().toFixed(2)}
              </p>
            </>
          )}
          <Divider></Divider>
          <p className="prezzo_parziale">
            {t("totale")} {datiScuola.valuta}{" "}
            {(
              parseFloat(appData.prefsCorso.prezzo) *
                parseInt(appData.prefsCorso.numAllievi) +
              getTotaleServizi()
            ).toFixed(2)}
          </p>
          <p className="prezzo_totale">
            {t("acconto")} {datiScuola.valuta}{" "}
            {(
              parseFloat(appData.prefsCorso.prezzoPag) *
              parseInt(appData.prefsCorso.numAllievi)
            ).toFixed(2)}
          </p>
        </Segment>
      );
    }
    return (
      <Segment textAlign="right" basic className="padding_5_lr">
        <label>{t("prezzo_corso")}</label>
        <p className="prezzo_parziale">
          <span>{appData.prefsCorso.numAllievi} x </span>
          {datiScuola.valuta} {appData.prefsCorso.prezzo.toFixed(2)}
        </p>
        {getTotaleServizi() > 0 && (
          <>
            <label>{t("totale_servizi")}</label>
            <p className="prezzo_parziale">
              {datiScuola.valuta} {getTotaleServizi().toFixed(2)}
            </p>
          </>
        )}
        <Divider></Divider>
        <p className="prezzo_totale">
          {t("totale")} {datiScuola.valuta}{" "}
          {(
            parseFloat(appData.prefsCorso.prezzo) *
              parseInt(appData.prefsCorso.numAllievi) +
            getTotaleServizi()
          ).toFixed(2)}
        </p>
        {datiScuola.tipoBanca_2 > 0 && (
          <ScalapayFrase
            prezzo={(
              (parseFloat(appData.prefsCorso.prezzo) *
                parseInt(appData.prefsCorso.numAllievi) +
                getTotaleServizi()) /
              3
            ).toFixed(2)}
            end={true}
          />
        )}
      </Segment>
    );
  }

  if (isLoading) {
    return <Loader></Loader>;
  } else {
    return (
      // <Dimmer.Dimmable as={Container} blurring dimmed={checkOutOpen}>
      <Container>
        <div className="head-offset"></div>
        <TestataPagina
          titolo={t("corsi_collettivi")}
          icon="group"
          sottoTitolo={t("inserisci_dati_allievi")}
        />
        <div ref={inizioAllieviRef}></div>
        <Segment
          className="padding_5_lr contenitore-grande"
          style={{ marginBottom: "30px" }}
        >
          {renderAllievi()}

          <Segment
            textAlign="right"
            basic
            className="padding_0_lr contenitore-grande"
          >
            {renderPrezzo()}
            <Segment
              basic
              textAlign={windowSize.width > 600 ? "right" : "center"}
            >
              <Button
                primary
                onClick={handleAggiuntaCarrello}
                disabled={!isValid}
                size={windowSize.width > 600 ? "big" : "large"}
              >
                <Icon name="cart arrow down" size="large" />
                {t("aggiungi_carrello")}
              </Button>
            </Segment>
          </Segment>
        </Segment>
        {/* <Dimmer active={checkOutOpen} page> */}{" "}
        {/* <TransitionablePortal
          transition={{ transition, duration }}
          open={checkOutOpen}
          onClose={() => {
            setCheckOutOpen(false);
          }}
        >
          <Segment
            basic
            style={{
              position: "fixed",
              height: "99%",
              zIndex: "100000",
            }}
          >
            <Segment
              style={{
                width: "80%",
                overflow: "auto",
                height: "100%",
                border: `5px ${
                  window.getComputedStyle(document.querySelector("body"))
                    .backgroundColor
                } solid`,
              }}
              floated="right"
            >
              <CartMain />
            </Segment>
          </Segment>
        </TransitionablePortal> */}
        <CartPortal open={checkOutOpen} onClose={handleCartPortalClose} />
        {/* </Dimmer> */}
      </Container>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    codScuola: ownProps.match.params.slug,
    lang: ownProps.match.params.lang,
    appData: state.appReducer,
    datiScuola: state.scuolaReducer,
    loading: state.apiCallsInProgress > 0,
  };
}

const mapDispatchToProps = {
  loadSchoolData: scuolaActions.loadSchoolData,
  addCollettiva: cartActions.addCollettiva,
  setReferrer: cartActions.setReferrer,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollettiveAllievi);
